/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createWebhusetOrderApiFeaturesCartFinalizeResponseFromDiscriminatorValue, serializeWebhusetOrderApiFeaturesCartFinalizeRequest, serializeWebhusetOrderApiFeaturesCartFinalizeResponse, type WebhusetOrderApiFeaturesCartFinalizeRequest, type WebhusetOrderApiFeaturesCartFinalizeResponse } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /cart/{cartId}/finalize
 */
export interface FinalizeRequestBuilder extends BaseRequestBuilder<FinalizeRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<WebhusetOrderApiFeaturesCartFinalizeResponse>}
     */
     put(body: WebhusetOrderApiFeaturesCartFinalizeRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<WebhusetOrderApiFeaturesCartFinalizeResponse | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: WebhusetOrderApiFeaturesCartFinalizeRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const FinalizeRequestBuilderUriTemplate = "{+baseurl}/cart/{cartId}/finalize";
/**
 * Metadata for all the requests in the request builder.
 */
export const FinalizeRequestBuilderRequestsMetadata: RequestsMetadata = {
    put: {
        uriTemplate: FinalizeRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        adapterMethodName: "send",
        responseBodyFactory:  createWebhusetOrderApiFeaturesCartFinalizeResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeWebhusetOrderApiFeaturesCartFinalizeRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
